import WorkProject from '../components/WorkProjectsList/WorkProjectItem/WorkProject';

const WorkProjectPage = ({ hideHeaderFooterSetter }) => {
  return (
    <>
      <WorkProject hideHeaderFooterSetter={hideHeaderFooterSetter} />
    </>
  );
};

export default WorkProjectPage;